import { render } from "./SingelCustomer.vue?vue&type=template&id=2af13d33&scoped=true"
import script from "./SingelCustomer.vue?vue&type=script&lang=js"
export * from "./SingelCustomer.vue?vue&type=script&lang=js"

import "./SingelCustomer.vue?vue&type=style&index=0&id=2af13d33&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af13d33"]])

export default __exports__